module.exports = __webpack_public_path__ + "img/ps-47.c28ce5ea.jpg";